import { faCheckCircle, faFileAlt, faHeart, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { Notification, NotificationType } from "./notification.types"

type NotificationDefinition = Pick<Notification, "title" | "text" | "icon" | "color" | "cta"> & {
  type: NotificationType
}

// L'ordre du tableau définit l'ordre d'affichage des notifications.
export const NOTIFICATION_DEFINITIONS: NotificationDefinition[] = [
  {
    type: "rps-survey-to-link",
    icon: faHeart,
    cta: "Importer",
    title: "Résultats enquête RPS disponible",
    text: "Vous pouvez importer les résultats de l'enquête RPS pour votre établissement.",
    color: "orange"
  },
  {
    type: "measures-missing",
    icon: faTriangleExclamation,
    //Libelle court : un bouton large recouvrirait le hibou de la carte
    cta: "Ajouter",
    title: "Risque sans mesure de prévention",
    //Une tache est emise par risque concerne : le texte est remplace par getMeasuresMissingText
    text: "Ce risque n'a aucune mesure de prévention.",
    color: "orange"
  },
  {
    type: "duerp-missing",
    icon: faFileAlt,
    cta: "Mettre à jour",
    title: "Document unique à créer",
    text: "Aucun document unique n'a encore été généré pour cet établissement.",
    color: "orange"
  },
  {
    type: "duerp-outdated",
    icon: faFileAlt,
    cta: "Mettre à jour",
    title: "Document unique à actualiser",
    text: "Le dernier document unique a été généré il y a plus de 12 mois.",
    color: "orange"
  },
  {
    type: "document-needs-generation",
    icon: faFileAlt,
    cta: "Mettre à jour",
    title: "Mise à jour document unique",
    text: "Vous avez effectué des changements depuis la dernière mise à jour du document unique.",
    color: "grey"
  },
  {
    type: "prevention-actions-without-date",
    icon: faCheckCircle,
    cta: "Mettre à jour",
    title: "Mesure de prévention sans date",
    //Une tache est emise par mesure concernee : le texte est remplace par getPreventionActionWithoutDateText
    text: "Cette mesure de prévention n'a pas de date planifiée.",
    color: "grey"
  }
]

/** Texte de la tache "mesure sans date", qui nomme la mesure concernee */
export function getPreventionActionWithoutDateText(actionName: string) {
  return actionName.trim() ? `La mesure « ${actionName.trim()} » n'a pas de date planifiée.` : ""
}

/** Texte de la tache "risque sans mesure", qui nomme le risque concerne */
export function getMeasuresMissingText(riskName: string) {
  return riskName.trim() ? `Le risque « ${riskName.trim()} » n'a aucune mesure de prévention.` : ""
}

export function getNotificationDefinition(type: NotificationType) {
  return NOTIFICATION_DEFINITIONS.find((definition) => definition.type === type)
}
